//API calls for bulk approval feature

import axios from "axios";
import { apiURI } from "../../../common";

export const ApprovalItemsList = {
  //get approval items list for relevant user (server-side paginated + searched
  //+ sorted: responds { rows, total, page, pageSize })
  get: async ({ requestURN, page, pageSize, search, sort }) =>
    await axios.get(`${apiURI}/form/${requestURN}`, {
      params: {
        page,
        pageSize,
        // Only send search / sort when active.
        ...(search ? { search } : {}),
        ...(sort ? { sort } : {}),
      },
    }),
  //post bulk approvals to be updated in sample details
  post: async ({ approval, selectedRowsData, email, role }) =>
    await axios.post(`${apiURI}/form/bulkUpdateApproval`, {
      approval,
      selectedRowsData,
      email,
      role,
    }),
};
